import { AlertCircle, CheckCircle } from "lucide-react";

export const PaymentLinkErrors = ({ invalidRows }) => {
  if (!invalidRows || invalidRows.length === 0) return null;

  return (
    <div className="p-4 bg-yellow-50 rounded-md border border-yellow-300">
      <div className="flex items-center mb-3">
        <AlertCircle className="w-5 h-5 text-yellow-600 mr-2" />
        <p className="font-semibold text-yellow-800 text-lg">
          Invalid Stripe Payment Links ({invalidRows.length})
        </p>
      </div>
      <p className="text-sm text-yellow-700 mb-3">
        The following parts will be skipped due to invalid Stripe payment links:
      </p>
      <div className="max-h-60 overflow-y-auto space-y-2">
        {invalidRows.slice(0, 10).map((item, index) => (
          <div
            key={index}
            className="text-sm text-yellow-800 bg-yellow-100 p-3 rounded shadow-sm"
          >
            <p className="font-medium">
              Row {item.rowNumber}: {item.partInfo}
            </p>
            <p className="text-xs text-yellow-700 mt-1">❌ {item.error}</p>
          </div>
        ))}
        {invalidRows.length > 10 && (
          <p className="text-sm text-yellow-800 font-medium mt-2">
            ... and {invalidRows.length - 10} more parts with invalid links
          </p>
        )}
      </div>
      <p className="text-sm flex text-yellow-700 mt-3 font-medium">
        <CheckCircle className="w-5 h-5 text-green-600 mr-2" /> All other parts
        will be uploaded successfully.
      </p>
    </div>
  );
};
